<template lang="pug">
	table.insurance-compare-table.mb-6
		colgroup
			col
			col(style="background-color:var(--v-info-base)")
		thead
			tr
				th
				th.pt-2(v-for="(provider, index) in insuranceprovidersByType" :key="provider.id")
					template(v-if="index == 0")
						span Ongekend goed!
						| Bij ons
					v-img(v-else max-height="35" contain :src="`https://static.wintersport.nl/images/nskiv/providers/${provider.id}.png`")
		tbody
			tr(v-for="(product, index) in insuranceproductsByType" :key="product.id")
				td {{product.title}}
				td.text-center(v-for="(rating, index) in providerratings[product.id]")
					ws-icon(v-if="rating.rating == 1" color="success" small) check
					ws-icon(v-if="rating.rating == 0" color="warning" small) tilde
					ws-icon(v-if="rating.rating == -1" color="error" small) cross
			tr
				td(v-if="type === 'shortterm'") Prijs per dag
				td(v-else) Prijs per maand
				td.text-center.accent--text.font-weight-bold(v-for="(provider, index) in insuranceprovidersByType" :key="provider.id" :class="{title: index==0}")
					| {{$n(provider.price, 'currency', $i18n.locale)}}
					.caption.d-block.grey--text(v-if="index == 0 && type === 'longterm'") *lidmaatschap van €3,75 verplicht
			tr
				td.clean &nbsp;
				td(v-for="(provider, index) in insuranceprovidersByType" :key="provider.id" v-if="provider.affiliateLink")
					v-btn(depressed color="warning" :to="provider.affiliateLink" block) bereken premie
</template>

<style lang="sass">
table.insurance-compare-table
	border-collapse: collapse
	table-layout: fixed
	width: 100%
	tr th
		position: relative
		border-bottom: 1px solid var(--v-border-base)
		padding: $spacer

		img
			display: block
			max-width: 100%
			max-height: 75px
			margin: 0 auto

		span
			position: absolute
			top: -30px
			left: -15px
			color: white
			font-weight: bold
			text-align: center
			width: 53px
			height: 53px
			border-radius: 50%
			padding-top: 16px
			line-height: 12px
			font-size: 60%
			background-color: var(--v-success-base)
			transform: rotate(-20deg)

			// @include media-breakpoint-down(sm)
			// 	top: -14px
			// 	width: 48px
			// 	height: 48px
			// 	line-height: .6rem
			// 	font-size: 54%

		&:first-child
			border-top: none

	tr > :first-child
		width: 260px

	tr th,
	tr td
		padding: $spacer
		vertical-align: top
		white-space: normal
		border-right: 1px solid var(--v-border-base)
		border-bottom: 1px solid var(--v-border-base)

	tr td.clean
		border-bottom: none !important
</style>

<script>
import sortBy from 'lodash/sortBy';

export default {
	props: [
		'type',
		'insuranceproviders',
		'insuranceproducts',
		'insuranceratings'
	],
	computed: {
		insuranceprovidersByType() {
			return this.insuranceproviders.filter(i => {
				return i.type === this.type;
			});
		},
		insuranceproductsByType() {
			const insuranceproducts = this.insuranceproducts.filter(i => {
				return i.type === this.type;
			});
			return sortBy(insuranceproducts, function (o) {
				return o.sortOrder;
			});
		},
		insuranceratingsByType() {
			return this.insuranceratings.filter(i => {
				return i.type === this.type;
			});
		},
		providerratings() {
			const result = {};
			this.insuranceratingsByType.forEach(r => {
				if (!(r.productId in result)) result[r.productId] = {};
				result[r.productId][r.providerId] = r;
			});
			return result;
		}
	}
};
</script>
